<template>
  <router-link
    :to="$buildContentLink('path', path)"
    :class="['path-tile', customClass]"
  >
    <div
      class="path-tile__primary"
      :style="
        `background-image: url(${$getPlaylistBackground(path.objectID)});`
      "
    >
      <div class="path-tile__mask"></div>
      <div class="path-tile__title-wrapper">
        <p
          class="path-tile__title"
          v-tooltip="{
            content: path.name.length >= maxLength ? path.name : '',
          }"
        >
          {{ path.name }}
        </p>
        <LPIcon class="path-tile__icon" />
      </div>
      <div class="path-tile__instructor-wrapper">
        <p class="path-tile__instructor-title">Primary Instructor</p>
        <p class="path-tile__instructor-name">
          {{
            path.instructors && path.instructors.length
              ? path.instructors[0].name
              : 'INE Instructor'
          }}
        </p>
      </div>
    </div>
    <div class="path-tile__secondary">
      <div class="path-tile__duration-wrapper">
        <p class="path-tile__secondary--title lead">Duration</p>
        <p class="path-tile__duration">
          {{ $duration.getCourseDuration(path) }}
        </p>
      </div>
      <div class="path-tile__difficulty-wrapper">
        <p class="path-tile__secondary--title lead">Difficulty</p>
        <Difficulty :difficulty="path.difficulty" :colored="true" />
      </div>
    </div>
  </router-link>
</template>

<script>
import Difficulty from '@/components/properties/Difficulty.vue'
import LPIcon from '@/assets/icons/navigation/learning_paths.svg'
import { truncateText } from '@/helpers'

export default {
  name: 'LearningPathTile',
  components: {
    Difficulty,
    LPIcon: { ...LPIcon, name: 'LPIcon' },
  },
  data() {
    return {
      maxLength: 80,
    }
  },
  props: {
    path: {
      type: Object,
      required: true,
    },
    customClass: {
      type: String,
      required: false,
    },
  },
  methods: {
    truncateTitle(value) {
      return truncateText(value, this.maxLength)
    },
  },
}
</script>

<style lang="scss">
.path-tile {
  height: 300px;
  min-height: 300px;
  min-width: 350px;
  text-align: left;
  background-color: var(--light-gray);
  color: var(--white);
  margin: 0 0 10px 0;
  text-decoration: none;
  padding: 5px;
  &:hover {
    .path-tile__mask {
      background: linear-gradient(
        to right,
        rgba(26, 26, 26, 1),
        rgba(26, 26, 26, 1),
        rgba(26, 26, 26, 0.8),
        rgba(0, 0, 0, 0.3),
        rgba(0, 0, 0, 0)
      );
    }
  }
  &__primary {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 217px;
    padding: 27px 37px;
    position: relative;
  }
  &__mask {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(
      to right,
      rgba(26, 26, 26, 1),
      rgba(26, 26, 26, 1),
      rgba(26, 26, 26, 0.5),
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0)
    );
    z-index: 0;
  }
  &__title-wrapper,
  &__instructor-wrapper {
    z-index: 1;
  }
  &__title-wrapper {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
  }
  &__title {
    color: var(--white);
    font-size: 1.1rem;
    margin: 0;
    padding: 0;
    max-width: 175px;
  }
  &__icon {
    fill: var(--white);
    margin: 7px 0 0 0;
    width: 35px;
    height: 28px;
  }
  &__instructor-title {
    color: var(--white);
    padding: 0;
    margin: 0;
    text-transform: uppercase;
    font-size: 0.7rem;
    font-weight: 700;
  }
  &__instructor-name {
    color: var(--white);
    padding: 0;
    margin: 1px 0 0 0;
    font-size: 1rem;
  }
  &__secondary {
    display: flex;
    margin: 10px 0 0 0;
    padding: 0 20px;
    position: relative;
    &--title {
      padding: 0;
      margin: 0 0 5px 0;
      text-transform: uppercase;
      font-size: 0.8rem;
    }
  }
  &__duration-wrapper {
    margin: 0 50px 0 0;
  }
  &__duration {
    padding: 0;
    margin: 0;
    color: var(--white);
    font-weight: 700;
    white-space: nowrap;
  }
}
</style>
